import Keycloak from 'keycloak-js'

export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig()

  if (import.meta.server) {
    // Keycloak is a client-side library, so we don't want to run this on the server
    return {
      provide: {},
    }
  }

  const keycloak = new Keycloak({
    url: config.public.keycloak.url,
    realm: config.public.keycloak.realm,
    clientId: config.public.keycloak.clientId,
  })

  const initialized = ref(false)
  const authenticated = ref(false)
  const token = ref<string | undefined>(undefined)

  const redirectUri = config.public.disableDelosSso ? window.location.href : config.public.delosSsoUrl

  return await keycloak.init({
    onLoad: 'login-required',
    checkLoginIframe: false, // Désactiver le contrôle de l'iframe de connexion pour éviter les problèmes de CORS
    enableLogging: config.enableLogging,
    flow: 'standard',
    redirectUri,
  }).then((auth) => {
    if (!auth) {
      keycloak.login({
        redirectUri,
      })
    }

    authenticated.value = auth
    initialized.value = true
    token.value = keycloak.token

    // Planification du rafraîchissement du token
    const refreshInterval = setInterval(() => {
      keycloak.updateToken(60)
        .then((refreshed) => {
          if (refreshed) {
            token.value = keycloak.token
          }
        })
        .catch((_) => {
          keycloak.login({
            redirectUri,
          })
        })
    }, 10000)

    // Nettoyage à la déconnexion ou changement de page
    window.addEventListener('beforeunload', () => clearInterval(refreshInterval))

    return {
      provide: {
        iproKeycloak: keycloak,
        iproInitialized: initialized,
        iproAuthenticated: authenticated,
        iproToken: token,
        iproUpdateToken: (minValidity = 60) => keycloak.updateToken(minValidity),
        iproTokenIsExpired: (minValidity = 30) => keycloak.isTokenExpired(minValidity),
      },
    }
  }).catch((err) => {
    // return page with error message
    console.error('[Keycloak] Init failed:', err)
    throw createError({ statusCode: 401, message: 'Erreur de connexion ! Veuillez réessayer.' })
  })
})
